/* eslint-disable */
Number.prototype.toRoman = function () {
  let num = this
  if (num <= 0) throw new Error('Number must be positive')

  const map = [
    [1000, 'M'],
    [900, 'CM'],
    [500, 'D'],
    [400, 'CD'],
    [100, 'C'],
    [90, 'XC'],
    [50, 'L'],
    [40, 'XL'],
    [10, 'X'],
    [9, 'IX'],
    [5, 'V'],
    [4, 'IV'],
    [1, 'I']
  ]

  let result = ''
  for (const [value, symbol] of map) {
    const count = Math.floor(num / value)
    result += symbol.repeat(count)
    num %= value
  }
  return result
}
